import React, { useState } from "react";

function AddressForm({ onChange }) {
  const [zipcode, setZipcode] = useState("");
  const [error, setError] = useState("");

  const handleZipcodeChange = async (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setZipcode(value);

    if (value.length !== 5) return;

      try {
        setError("");
        //const response = await fetch(`/api/zipcode?cp=${value}`);
        const response = await fetch(`https://api.miplayera.com.mx/api/zip/${value}`);

        
        const data = await response.json();

        if (!data?.colonias?.length) {
          setError("Código postal no encontrado");
          if (onChange) onChange(null);
          return;
        }

        const payload = {
          estado: data.estado,
          estado_abreviatura: data.estado_abreviatura,
          municipio: data.municipio,
          codigo_postal: data.codigo_postal,
          colonias: data.colonias,
        };

        if (onChange) onChange(payload);
      } catch (err) {
        setError("Error consultando el servicio");
        if (onChange) onChange(null);
      }

  };

  return (
    <>
      <input
        type="text"
        placeholder="Código Postal"
        value={zipcode}
        maxLength={5}
        onChange={handleZipcodeChange}
      />
      {error && <p style={{ color: "red" }}>{error}</p>}
    </>
  );
}

export default AddressForm;
